 function Default_templatejs(){
    var custom_val1 = $(".custom__varoption--1 option:selected").val();
    var custom_val2 = $(".custom__varoption--2 option:selected").val();
 var custom_val3 = $(".custom__varoption--3 option:selected").val();
    var finalop = '';
    if (custom_val1) {
        finalop += custom_val1;
      }
    if (custom_val2) {
        finalop += (finalop ? ' / ' : '') + custom_val2;
      }
      if (custom_val3) {
        finalop += (finalop ? ' / ' : '') + custom_val3;
      }
  console.log("finalop",finalop); 
    
    $('.custom__combo-opitons option').removeAttr('selected');
    var comoboo_cst_mm =  $(".custom__combo-opitons option").map(function () {
      if ($(this).attr("data-vartitle"))
      return $(this).attr("data-vartitle");
      }).get();
  console.log("comoboo_cst_mm",comoboo_cst_mm);
      if(jQuery.inArray(finalop.toString(), comoboo_cst_mm) >= 0){   
       var selected_opiton =  $('.custom__combo-opitons option[data-vartitle="' + finalop + '"]').attr("selected", "selected");  
       var selected_price = selected_opiton.attr("data-pricing");
       $("#ProductPrice").html(selected_price);
console.log("selected_price",selected_price);
      }

}
Default_templatejs();
$(".custom__variants").on("change", function() {
  Default_templatejs();
});



